import {Injectable} from "@angular/core";
import {DataResponse} from "src/app/models/http.models";
import { Observable } from "rxjs";
import {BaseApiService} from "./_baseApiService";
import {
  AnnunciFiltri,
  AnnunciInEvidenza,
  Annuncio,
  CommesseAnnuncioFacetPortal,
  CommesseAnnunciPortals, IdAnnuncioModel
} from "../../models/annunci.models";
import { CCNLSettore } from "src/app/models/preferenze.models";
import {Provincia, Regione} from "../../models/comuni.models";

@Injectable()

export class JobPostService extends BaseApiService{
  public candidaturaAnnuncio(idAnnuncio : number):Observable<DataResponse<Response>>{
    return this.httpService.get(`PortalsAnnunci/CandidaturaAnnuncio?IdAnnuncio=`+idAnnuncio);
  }

  public getJobPostBy(model : IdAnnuncioModel):Observable<DataResponse<AnnunciInEvidenza>>{
    return this.httpService.get(`PortalsAnnunci/AnnuncioGetById`, model);
  }

  public getAnnunciInEvidenza():Observable<DataResponse<AnnunciInEvidenza>>{
    return this.httpService.post(`PortalsAnnunci/AnnunciInEvidenza`);
  }

  public getRegione(nome : string): Observable<DataResponse<Regione>>{
    return this.httpService.post(`PortalsAnnunci/RegioniGetList?nome=`+nome);
  }

  public getProvincia(nome : string):Observable<DataResponse<Provincia>>{
    return this.httpService.post(`PortalsAnnunci/ProvinciaGetList?nome=`+nome);
  }

  public getSettoreAutoComplete(description : string):Observable<DataResponse<CCNLSettore>>{
    return this.httpService.get(`PortalsAnnunci/RicercaSettori?description=`+description)
  }

  public getTipoContratto(tipo : string):Observable<DataResponse<Annuncio>>{
    return this.httpService.get(`PortalsAnnunci/TipoContrattoGetList?tipo=`+tipo)
  }

  public getAnnunciFiltrati(model : AnnunciFiltri):Observable<DataResponse<CommesseAnnuncioFacetPortal>>{
    return this.httpService.post(`PortalsAnnunci/CommesseGetListAnnunciPubbliciPortaleCandidati`, model)
  }

}
